export const setupStopReferrerHack = () => {
  const externalLinks = document.querySelectorAll(
    'a[target="_blank"], a[target="new"]',
  );

  externalLinks.forEach((link) => {
    link.setAttribute("rel", "noopener noreferrer");
  });
};
